import { constructEnum } from '@/lib/enum';

export default constructEnum('MediaOrientation', {
  NONE: 0,
  LANDSCAPE: 1,
  PORTRAIT: 2
});
